module.exports = __webpack_public_path__ + "static/media/img_step_6.581f4dbe.jpg";